import { AbstractControl } from '@angular/forms';

export class PasswordValidator {

  static matchPassword(AC: AbstractControl) {
   let password = AC.get('password').value; 
   let confirmPassword = AC.get('confirmPassword').value;
    if (!confirmPassword) {
      if (AC.get('confirmPassword').hasError('matchPassword')) {
        delete AC.get('confirmPassword').errors['matchPassword']
        AC.get('confirmPassword').updateValueAndValidity();
      }
   }
    if(password != confirmPassword) {
      AC.get('confirmPassword').setErrors({ 
      	matchPassword: true 
      });
    }
  }

}